"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { Distribution } from "@/entities/IDistribution";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import type { Page } from "@/helpers/Types";
import { commonApiFetch } from "@/services/api/common-api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { WALLET_DISTRIBUTION_PAGE_PARAM } from "../UserPageActivityWrapper";
import UserPageStatsActivityDistributionsTableWrapper from "./UserPageStatsActivityDistributionsTableWrapper";
export default function UserPageStatsActivityDistributions(t0) {
  const $ = _c(48);
  const {
    profile,
    activeAddress
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get(WALLET_DISTRIBUTION_PAGE_PARAM);
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const page = t1;
  const [pageFilter, setPageFilter] = useState(page && !isNaN(+page) ? +page : 1);
  let t2;
  let t3;
  if ($[2] !== page) {
    t2 = () => {
      setPageFilter(page && !isNaN(+page) ? +page : 1);
    };
    t3 = [page];
    $[2] = page;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== searchParams) {
    t4 = config => {
      const params = new URLSearchParams(searchParams?.toString() ?? "");
      for (const {
        name,
        value
      } of config) {
        params.set(name, value);
      }
      return params.toString();
    };
    $[5] = searchParams;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const createQueryString = t4;
  let t5;
  if ($[7] !== createQueryString || $[8] !== pathname || $[9] !== router) {
    t5 = page_0 => {
      router.replace(`${pathname}?${createQueryString([{
        name: WALLET_DISTRIBUTION_PAGE_PARAM,
        value: `${page_0}`
      }])}`, {
        scroll: false
      });
    };
    $[7] = createQueryString;
    $[8] = pathname;
    $[9] = router;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const onPageFilter = t5;
  const [totalPages, setTotalPages] = useState(1);
  let t6;
  if ($[11] !== activeAddress || $[12] !== profile) {
    t6 = () => [activeAddress?.toLowerCase() ?? profile.wallets?.map(_temp)].join(",");
    $[11] = activeAddress;
    $[12] = profile;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const getWalletsParam = t6;
  const [walletsParam, setWalletsParam] = useState(getWalletsParam());
  let t7;
  if ($[14] !== getWalletsParam) {
    t7 = () => {
      setWalletsParam(getWalletsParam());
    };
    $[14] = getWalletsParam;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== activeAddress || $[17] !== profile) {
    t8 = [activeAddress, profile];
    $[16] = activeAddress;
    $[17] = profile;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  useEffect(t7, t8);
  const t9 = `${pageFilter}`;
  let t10;
  if ($[19] !== t9 || $[20] !== walletsParam) {
    t10 = [QueryKey.PROFILE_DISTRIBUTIONS, {
      page_size: "10",
      page: t9,
      wallet: walletsParam
    }];
    $[19] = t9;
    $[20] = walletsParam;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== pageFilter || $[23] !== walletsParam) {
    t11 = async () => await commonApiFetch({
      endpoint: "distributions",
      params: {
        page_size: "10",
        page: `${pageFilter}`,
        wallet: walletsParam
      }
    });
    $[22] = pageFilter;
    $[23] = walletsParam;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t10 || $[26] !== t11) {
    t12 = {
      queryKey: t10,
      queryFn: t11,
      placeholderData: keepPreviousData
    };
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  const {
    isFetching,
    isLoading: isFirstLoading,
    data
  } = useQuery(t12);
  let t13;
  if ($[28] !== data || $[29] !== isFetching || $[30] !== onPageFilter || $[31] !== pageFilter) {
    t13 = () => {
      if (isFetching) {
        return;
      }
      if (!data?.count) {
        onPageFilter(1);
        setTotalPages(1);
        return;
      }
      const totalPages_0 = Math.ceil(data.count / 10);
      if (totalPages_0 < pageFilter) {
        onPageFilter(totalPages_0);
      }
      setTotalPages(totalPages_0);
    };
    $[28] = data;
    $[29] = isFetching;
    $[30] = onPageFilter;
    $[31] = pageFilter;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  const t14 = data?.count;
  const t15 = data?.page;
  let t16;
  if ($[33] !== isFetching || $[34] !== t14 || $[35] !== t15) {
    t16 = [t14, t15, isFetching];
    $[33] = isFetching;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  useEffect(t13, t16);
  let t17;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="tw-flex"><h3 className="tw-mb-0 tw-text-lg tw-font-semibold tw-text-iron-100">Distributions</h3></div>;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== data?.data) {
    t18 = data?.data ?? [];
    $[38] = data?.data;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== isFetching || $[41] !== isFirstLoading || $[42] !== onPageFilter || $[43] !== pageFilter || $[44] !== profile || $[45] !== t18 || $[46] !== totalPages) {
    t19 = <div className="tw-mt-4 md:tw-mt-5">{t17}<UserPageStatsActivityDistributionsTableWrapper data={t18} profile={profile} isFirstLoading={isFirstLoading} loading={isFetching} page={pageFilter} totalPages={totalPages} setPage={onPageFilter} /></div>;
    $[40] = isFetching;
    $[41] = isFirstLoading;
    $[42] = onPageFilter;
    $[43] = pageFilter;
    $[44] = profile;
    $[45] = t18;
    $[46] = totalPages;
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  return t19;
}
function _temp(w) {
  return w.wallet.toLowerCase();
}